import { combineReducers } from 'redux';

import list from './list/slice';
import share from './share/slice';

const inquiriesReducer = combineReducers({
  list,
  share,
});

export default inquiriesReducer;
